import { render, staticRenderFns } from "./OpeningSelection.vue?vue&type=template&id=54e5c733&name=opening-selection&"
import script from "./OpeningSelection.vue?vue&type=script&lang=js&"
export * from "./OpeningSelection.vue?vue&type=script&lang=js&"
import style0 from "./OpeningSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports